<template>
  <div class="modal_wrap" :class="{ on: isOpen }">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <!--<h1 class="h1"></h1>-->
        </div>
        <div class="modal_con">
          <div class="shop_index">
            <dl>
              <dt><i class="i_chart"></i>응답률</dt>
              <dd>{{ _store.responseRate }} %</dd>
            </dl>
            <dl>
              <dt><i class="i_star"></i>평가</dt>
              <dd>{{ _store.evaluationScore }}점</dd>
            </dl>
            <dl>
              <dt><i class="i_heart"></i>관심매장</dt>
              <dd>{{ _store.followCnt }}건</dd>
            </dl>
            <dl>
              <dt><i class="i_chat"></i>상담</dt>
              <dd>{{ _store.chatCnt }}건</dd>
            </dl>
            <dl>
              <dt><i class="i_time"></i>상담 가능 시간</dt>
              <dd
                v-if="
                  _store.counselStart == '00:00' && _store.counselEnd == '24:00'
                "
              >
                종일
              </dd>
              <dd v-else>
                {{ _store.counselStart }} ~ {{ _store.counselEnd }}
              </dd>
            </dl>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn" v-on:click="$emit('close')">닫기</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: Boolean,
    store: Object,
  },
  name: 'StoreProfile',
  computed: {
    _store() {
      return this.store || {};
    },
  },
};
</script>
